import { createApi } from '@reduxjs/toolkit/query/react';
import { EReduxQueryTags } from 'shared/types/api.interface';
import { baseQueryWithReauth } from 'redux/customBaseQuery/customeBaseQuery';

export const splitApi = createApi({
  reducerPath: 'splitApi',
  tagTypes: [
    EReduxQueryTags.User,
    EReduxQueryTags.Challenge,
    EReduxQueryTags.Debate,
    EReduxQueryTags.CurrentDebate,
    EReduxQueryTags.CurrentChallenge,
  ],
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});
